import { Component, inject } from '@angular/core';
import { AuthenticationService } from '../../security/authentication.service';
import { faPlay, faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-agency-header',
  templateUrl: './agency-header.component.html',
  styleUrls: ['./agency-header.component.scss'],
  imports: [
    FaIconComponent
  ],
  standalone: true
})
export class AgencyHeaderComponent {
  authenticationService = inject(AuthenticationService);

  protected readonly faPlay = faPlay;
  protected readonly faUserSecret = faUserSecret;
}
